import { useI18n } from '~/stores/i18n';

import langCodes from '../../resources/languages.json';

export const makeLocalizedUrl = (source) => {
  const langCode = useI18n.getState().lang;
  let localizedUrl = source;
  const [first, ...rest] = source.match(/([^/]+)/g);
  if (langCodes.includes(first)) {
    if (first !== langCode && langCode !== 'en') {
      localizedUrl = '/' + [langCode, ...rest].join('/');
    }
  } else {
    localizedUrl = `${langCode !== 'en' ? `/${langCode}` : ''}${source}`;
  }
  return localizedUrl;
};
